import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // 前台页面路由
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('@/views/Products.vue'),
    meta: { title: '产品中心' }
  },
  {
    path: '/products/:id',
    name: 'ProductDetail',
    component: () => import('@/views/ProductDetail.vue'),
    meta: { title: '产品详情' }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue'),
    meta: { title: '关于我们' }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/Contact.vue'),
    meta: { title: '联系我们' }
  },
  
  // 后台管理路由
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('@/views/admin/login/Login.vue'),
    meta: { title: '管理员登录', requiresAuth: false }
  },
  {
    path: '/admin',
    component: () => import('@/views/admin/layout/AdminLayout.vue'),
    redirect: '/admin/dashboard',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: () => import('@/views/admin/dashboard/Dashboard.vue'),
        meta: { title: '仪表盘', icon: 'Odometer' }
      },
      {
        path: 'products',
        name: 'AdminProducts',
        component: () => import('@/views/admin/products/ProductList.vue'),
        meta: { title: '产品管理', icon: 'Goods' }
      },
      {
        path: 'categories',
        name: 'AdminCategories',
        component: () => import('@/views/admin/categories/CategoryList.vue'),
        meta: { title: '分类管理', icon: 'Menu' }
      },
      {
        path: 'i18n',
        name: 'AdminI18n',
        component: () => import('@/views/admin/i18n/I18nManagement.vue'),
        meta: { title: '多语言管理', icon: 'ChatDotRound' }
      },
      {
        path: 'banner',
        name: 'AdminBanner',
        component: () => import('@/views/admin/banner/BannerManagement.vue'),
        meta: { title: '轮播图管理', icon: 'Picture' }
      },
      {
        path: 'customer-service',
        name: 'AdminCustomerService',
        component: () => import('@/views/admin/config/CustomerServiceManagement.vue'),
        meta: { title: '客服管理', icon: 'Service' }
      },
      {
        path: 'inquiry',
        name: 'AdminInquiry',
        component: () => import('@/views/admin/inquiry/Index.vue'),
        meta: { title: '询价管理', icon: 'Promotion' }
      },
      {
        path: 'config',
        name: 'AdminConfig',
        component: () => import('@/views/admin/config/Config.vue'),
        meta: { title: '系统配置', icon: 'Setting' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 捕获租户ID（从URL参数保存到localStorage，供后续请求使用）
  const tenantId = to.query.tenant_id || to.query.tenantId || to.query.tenant
  if (tenantId) {
    localStorage.setItem('tenant_id', String(tenantId))
  }

  const token = localStorage.getItem('admin_token')
  
  // 检查当前路由或其父路由是否需要认证
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth !== false && (record.meta.requiresAuth || record.path.startsWith('/admin')))
  
  if (requiresAuth && !token) {
    // 需要认证但没有token，跳转到登录页
    next('/admin/login')
  } else if (to.path === '/admin/login' && token) {
    // 已登录用户访问登录页，跳转到仪表盘
    next('/admin/dashboard')
  } else {
    next()
  }
})

export default router